module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "task-actions"
  }, [_c('div', {
    staticClass: "task-actions-assignee"
  }, [_c('div', {
    staticClass: "task-actions-title"
  }, [_vm._v("\n      Assignee\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "task-actions-body"
  }, [_c('app-select', {
    staticClass: "task-actions-selector assignee-type",
    attrs: {
      "searchable": true,
      "customType": "assignee",
      "options": _vm.taskAssigneeForSelect,
      "imageBase": _vm.imageBase,
      "customActive": false,
      "clearable": false,
      "placeholder": "Type in a name...",
      "data-vv-name": "Assignee",
      "data-lpignore": "true",
      "name": "assignee",
      "id": "assignee"
    },
    on: {
      "change": function($event) {
        return _vm.changeTaskAssignee()
      }
    },
    model: {
      value: (_vm.taskAssignee),
      callback: function($$v) {
        _vm.taskAssignee = $$v
      },
      expression: "taskAssignee"
    }
  })], 1)]), _vm._v(" "), (_vm.taskStatus) ? _c('div', {
    staticClass: "task-actions-status"
  }, [_c('div', {
    staticClass: "task-actions-title"
  }, [_vm._v("\n      Status\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "task-actions-body"
  }, [_c('app-select', {
    staticClass: "task-actions-selector status-type",
    class: 'status-type-' + _vm.taskStatus.value,
    attrs: {
      "searchable": false,
      "customType": "status",
      "options": _vm.taskStatusesForSelectBasedOnTaskAssessment,
      "customActive": false,
      "clearable": false,
      "data-vv-name": "Status",
      "data-lpignore": "true",
      "name": "status",
      "id": "status"
    },
    on: {
      "change": function($event) {
        return _vm.changeTaskStatus()
      }
    },
    model: {
      value: (_vm.taskStatus),
      callback: function($$v) {
        _vm.taskStatus = $$v
      },
      expression: "taskStatus"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.taskBoard) ? _c('div', {
    staticClass: "task-actions-move-to"
  }, [_c('div', {
    staticClass: "task-actions-title"
  }, [_vm._v("\n      Board\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "task-actions-body"
  }, [_c('app-select', {
    staticClass: "task-actions-selector board-type",
    class: 'board-type-' + _vm.taskBoard.value,
    attrs: {
      "searchable": false,
      "options": _vm.taskBoardsForSelect,
      "customActive": false,
      "clearable": false,
      "data-vv-name": "Board",
      "data-lpignore": "true",
      "name": "board",
      "id": "board"
    },
    on: {
      "change": function($event) {
        return _vm.changeTaskBoard()
      }
    },
    model: {
      value: (_vm.taskBoard),
      callback: function($$v) {
        _vm.taskBoard = $$v
      },
      expression: "taskBoard"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.isAdmin) ? _c('button', {
    staticClass: "reset-task-messages background-1-20 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetTaskMessages()
      }
    }
  }, [_vm._v("\n      Reset task history\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b8ee6fa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tasks/includes/TaskActions.vue
// module id = 960
// module chunks = 0